if (!customElements.get("media-gallery")) {
	customElements.define(
		"media-gallery",
		class MediaGallery extends HTMLElement {
			connectedCallback() {
				// Elements
				this.thumbsComp = this.querySelector(
					'swiper-component[data-role="thumbs"]',
				);
				this.mainComp =
					this.querySelector("swiper-component[data-thumbs-for]") ||
					this.querySelector('swiper-component:not([data-role="thumbs"])');

				this.mainWrapper =
					this.mainComp?.querySelector(".swiper-wrapper") || null;
				this.thumbsWrapper =
					this.thumbsComp?.querySelector(".swiper-wrapper") || null;

				this._bindSwiper(this.mainComp, (inst) => {
					this.mainSwiper = inst;
				});
				this._bindSwiper(this.thumbsComp, (inst) => {
					this.thumbsSwiper = inst;
				});

				// === Mobile auto-scroll to top on variant change (same product) ===
				this._unsubVariantChange =
					window?.FoxThemeEvents?.subscribe && PUB_SUB_EVENTS?.variantChange
						? window.FoxThemeEvents.subscribe(
								PUB_SUB_EVENTS.variantChange,
								({ data }) => {
									try {
										if (!data) return;
										const { sectionId } = data;
										const mySectionId =
											this.dataset.sectionId ||
											this.getAttribute("data-section-id");
										if (
											mySectionId &&
											String(sectionId) !== String(mySectionId)
										)
											return;
										if (!this._isMobile()) return;
										window.scrollTo({ top: 0, behavior: "smooth" });
									} catch (_) {}
								},
							)
						: null;

				// Fallback for themes that dispatch a DOM event instead of PUB_SUB
				if (!this._unsubVariantChange) {
					this._variantChangedHandler = () => {
						if (!this._isMobile()) return;
						window.scrollTo({ top: 0, behavior: "smooth" });
					};
					document.addEventListener(
						"variant:changed",
						this._variantChangedHandler,
					);
				}
			}
			disconnectedCallback() {
				if (this._unsubVariantChange) {
					try {
						this._unsubVariantChange();
					} catch (_) {}
					this._unsubVariantChange = null;
				}
				if (this._variantChangedHandler) {
					document.removeEventListener(
						"variant:changed",
						this._variantChangedHandler,
					);
					this._variantChangedHandler = null;
				}
			}

			getSelectedVariant() {
				const selectedVariant = this.querySelector(
					"[data-selected-variant]",
				)?.innerHTML;
				return !!selectedVariant ? JSON.parse(selectedVariant) : null;
			}

			_getPosition() {
				const selectedVariant = this.getSelectedVariant();
				if (!selectedVariant) return null;
				const position = selectedVariant?.featured_media.position;
				return position;
			}

			setActiveMedia(position) {
				const swiperComponent = this.mainComp;

				if (!swiperComponent || position === null || position === undefined)
					return;

				const runSlideTo = () => {
					if (typeof swiperComponent.select === "function") {
						swiperComponent.select(position, false);
					}
				};

				if (swiperComponent.swiper) {
					runSlideTo();
				} else if (typeof swiperComponent.onReady === "function") {
					swiperComponent.onReady(() => {
						runSlideTo();
					});
				} else {
					swiperComponent.addEventListener(
						"swiper:ready",
						() => {
							runSlideTo();
						},
						{ once: true },
					);
				}
			}

			_isMobile() {
				if (typeof window.FoxThemeSettings?.isMobile === "boolean") {
					return window.FoxThemeSettings.isMobile;
				}
				return window.matchMedia("screen and (max-width: 767px)").matches;
			}

			_bindSwiper(comp, assign) {
				if (!comp) return;
				if (comp.swiper) {
					assign(comp.swiper);
					return;
				}
				const onReady = (e) => {
					assign(e.detail?.instance || comp.swiper);
				};
				comp.addEventListener("swiper:ready", onReady, { once: true });
			}
		},
	);
}
